import React, { useState, useEffect } from "react";
import BannerPNG from "../assets/PortfolioSkillLogos_AdobeExpress.png";
import "../styles/Banner.css";

function Banner() {
  const [scrollPosition, setScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollPosition(window.scrollY);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className="banner">
      <div className="banner-content" style={{ transform: `translateX(-${scrollPosition / 2}px)` }}>
        <img src={BannerPNG} alt="Banner" />
      </div>
    </div>
  );
}

export default Banner;


  